// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__pw1JJ","main":"siteloader_main__wnLO6","center":"siteloader_center__Obzci","middle":"siteloader_middle__QGPAq","top":"siteloader_top__yM2RY"};